module.exports = __webpack_public_path__ + "img/w19-b1.ce2577ff.jpg";